import type { LucideIcon } from 'lucide-react'
import { SearchX } from 'lucide-react'

import { cn } from '@/lib/utils'

export function EmptyState({
  icon: Icon = SearchX,
  title,
  description,
  action,
  className,
}: {
  icon?: LucideIcon
  title: string
  description?: string
  action?: React.ReactNode
  className?: string
}) {
  return (
    <div
      className={cn(
        'text-muted-foreground flex flex-col items-center justify-center gap-2 rounded-lg border border-dashed p-10 text-center',
        className,
      )}
    >
      <Icon className="size-8" />
      <p className="text-foreground font-medium">{title}</p>
      {description && <p className="max-w-sm text-sm">{description}</p>}
      {action && <div className="mt-2">{action}</div>}
    </div>
  )
}
